// src/components/form/fields/TextField.tsx
import React from 'react';
import { Input } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { FieldInfoMessage } from './FieldInfoMessage';
import { ClearButton } from './ClearButton'; // Import the ClearButton component

export const TextField = (props: any) => {
  const { name, label, disabled, placeholder, infoMessage, required } = props;
  const { handleChange, handleBlur, values } = useFormikContext<any>();

  return (
    <FormFieldWrapper name={name} label={label} required={required}>
      <Input
        name={name}
        value={values[name] || ''} // Ensure value is a string
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        suffix={!disabled && <ClearButton {...props} />} // Add suffix only if not disabled
        className="rounded-xl border-gray-200 hover:border-blue-300 focus:border-blue-500 focus:shadow-lg transition-all duration-200 text-base"
      />
      {infoMessage && <FieldInfoMessage message={infoMessage} />}
    </FormFieldWrapper>
  );
};
